export default __webpack_public_path__ + "static/media/iconTonsOfFun.0d005c94.svg";